import { Box, CircularProgress, Container, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import useHomePage from "./hooks/useHomePage";
import LeadsLineGraph from "../../components/charts/LeadsLineGraph";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import DataDisplayCard from "../../components/molecules/DataDisplayCard";
import ErrorBoundaryPage from "../error/ErrorBoundaryPage";

export interface HomePageFilter {
    requency: string;
}

const HomePage = () => {
    const { t } = useTranslation();
    const { isLoadingHomeLeadsData, overviewData, handleFrequencyChange, frequency, graphData } = useHomePage();

    return (
              <ErrorBoundary fallback={<ErrorBoundaryPage/>}>

        <Container maxWidth={false} sx={{ maxWidth: { xs: "100%", lg: "1800px" } }}>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                my: "24px",
                gap: 2,

            }}>
                <Typography variant="body_large" sx={{ color: "#666", fontWeight: 500 }}>
                    {t("platform.viewBy")}
                </Typography>
                <ToggleButtonGroup
                    value={frequency}
                    exclusive
                    onChange={handleFrequencyChange}
                    aria-label="View frequency"
                    sx={{
                        backgroundColor: "white",
                        borderRadius: "25px",
                        gap: 0,
                        border: "solid 1px #DBDFE1",
                        "& .MuiToggleButtonGroup-grouped": {
                            border: "none !important",
                            borderRadius: "20px !important",
                            margin: "0 2px",
                            padding: "8px 24px",
                            fontWeight: 500,
                            textTransform: "none",
                            fontSize: "14px",
                            "&.Mui-selected": {
                                backgroundColor: "#E87722 !important",
                                color: "#ffffff !important",
                                border: "none !important",
                                "&:hover": {
                                    backgroundColor: "#E87722 !important",
                                },
                            },
                            "&:not(.Mui-selected)": {
                                backgroundColor: "transparent",
                                color: "black",
                                border: "none !important",
                                "&:hover": {
                                    backgroundColor: "#e0e0e0",
                                },
                            },
                        },
                    }}
                >
                    <ToggleButton value="weekly">{t("platform.weekly")}</ToggleButton>
                    <ToggleButton value="monthly">{t("platform.monthly")}</ToggleButton>
                    <ToggleButton value="annually">{t("platform.annually")}</ToggleButton>
                </ToggleButtonGroup>
            </Box>

            <Box sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(1, 1fr)",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(4, 1fr)",
                    lg: "repeat(7, 1fr)",
                    xl: "repeat(7, 1fr)"
                },
                gap: 2,
                width: "100%",
                mb: 3
            }}>
                {
                    isLoadingHomeLeadsData ?
                        <Box sx={{
                            gridColumn: "1 / -1", // Span all columns
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "150px"
                        }}>
                            <CircularProgress size={24} />
                        </Box>
                        : (
                            overviewData.map((item, index) => {
                                return (
                                    <DataDisplayCard
                                        key={index}
                                        icon={item.icon}
                                        title={item.label}
                                        value={item.value}
                                    />
                                )
                            })
                        )
                }
            </Box>


            <LeadsLineGraph
                xAxisData={graphData.xAxisData}
                yAxisData={graphData.yAxisData}
                title={
                    frequency === "weekly"
                        ? t("platform.leadsByDayOfWeek")
                        : frequency === "monthly"
                            ? t("platform.leadsByMonth")
                            : t("platform.leadsByYear")}
            />


        </Container>        
        </ErrorBoundary>
    )

}

export default HomePage;